import { FloorplanTransmitter } from "@domain/project/floorplan/floorplan-transmitter";
import { FloorplanTransmitterPlaceholder } from "@domain/project/floorplan/floorplan-transmitter-placeholder";
import { FloorplanWorkspaceKonvaAdapter } from "@project/floorplanner/konva/floorplan-workspace-konva.adapter";
import { Circle } from "konva/lib/shapes/Circle";

export class MonitoringAreaKonva {
  private static readonly BASE_STROKE_WIDTH = 1;
  static init(transmitter: FloorplanTransmitter | FloorplanTransmitterPlaceholder) {
    const isPlaceholder = transmitter instanceof FloorplanTransmitterPlaceholder;
    const circle = new Circle({
      radius: transmitter.monitoringAreaRadius,
      fill: "#0091F733",
      stroke: "#002766",
      strokeWidth: MonitoringAreaKonva.BASE_STROKE_WIDTH,
      dash: [12, 12],
      dashEnabled: isPlaceholder,
    });

    circle.on("transform", () => {
      // Use radius directly instead of width/height to avoid setting circle.radius() twice per frame
      // (Konva's width/height setters both delegate to radius internally)
      const scale = (circle.scaleX() + circle.scaleY()) / 2;
      circle.radius(Math.max(2.5, circle.radius() * scale));
      circle.scaleX(1);
      circle.scaleY(1);
    });
    circle.on("transformend", () => (transmitter.monitoringAreaRadius = circle.radius()));

    circle.setAttr(FloorplanWorkspaceKonvaAdapter.OBJECT_KEY, transmitter);
    return circle;
  }

  static applyInitialScale(circle: Circle, scale: number): void {
    // Sync stroke to the icon's current scale without adjusting the radius.
    // The saved radius already encodes the correct centre-of-stroke position for the
    // stroke width that was active when the transmitter was last persisted.
    circle.strokeWidth(MonitoringAreaKonva.BASE_STROKE_WIDTH * scale);
  }

  static setPosition(circle: Circle, parentX: number, parentY: number, parentSize: number) {
    circle.x(parentX + parentSize / 2);
    circle.y(parentY + parentSize / 2);
  }

  static setStrokeWidth(circle: Circle, scale: number) {
    // Use the absolute scale so the stroke is always BASE × scaleX, regardless of
    // the scale at which the transmitter was initially loaded.
    const newStrokeWidth = MonitoringAreaKonva.BASE_STROKE_WIDTH * scale;

    // Shrink radius by half the stroke delta so the stroke moves inward and the outer diameter stays constant
    const previousStrokeWidth = circle.strokeWidth();
    const strokeDelta = newStrokeWidth - previousStrokeWidth;
    circle.radius(Math.max(0, circle.radius() - strokeDelta / 2));
    circle.strokeWidth(newStrokeWidth);
  }
}
